import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useQuery } from "react-query"
import { FormQueryKeys } from "../constants/FormQueryKeys"
import { DataBaseService } from "../services/DatabaseService"
import { LanguageOption } from "../types/LanguageOption"

export function useGetReferralById(id: string, useVersion2?: boolean) {
  const { i18n } = useTranslation()

  const language = i18n.resolvedLanguage as LanguageOption
  const { data, isLoading, error, isFetching, refetch } = useQuery(
    FormQueryKeys.byIdLanguageAndVersion(id, language, useVersion2),
    () => DataBaseService.getReferralById(id, language, useVersion2),
    { useErrorBoundary: true },
  )

  useEffect(() => {
    if (useVersion2) refetch()
  }, [useVersion2, refetch])

  return { data, isLoading, isFetching, error, refetch }
}
